module.exports = __webpack_public_path__ + "b824ffd60decd28db6ce5d36701199a5.jpg";